import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { Customer } from 'src/features/customers/utils/types';
import { CustomerFormSchemaValues } from 'src/features/customers/utils/formSchema';

const RESOURCE = '/customers/customer/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: CustomerFormSchemaValues): Promise<Customer> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateCustomer };
